import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import appParameters from '../../components/utils/AppParameters';
import { hideMenus } from '../../actions/MenuActions';
import menuType from '../../constants/MenuType';
import properties from '../../constants/Properties';
import masterUniverseUtils from '../utils/MasterUniverseUtils';

const ClipartSelectorButtonExpandedContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        if (this.isAvailable() == false)
            return;

        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        if (this.isAvailable() == false)
            return;

        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (this.isAvailable() == false)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (this.isAvailable() == false)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeUniverse();
    },
    onClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeUniverse();
    },
    changeUniverse() {
        var currentVideoTheme = appParameters.currentVideoTheme;

        if (currentVideoTheme != this.props.value.name) {
            appParameters.currentVideoTheme = this.props.value.name;
            masterUniverseUtils.reloadVideoClipart();
        }

        this.props.dispatch(hideMenus([menuType.UNIVERSES_MENU]));
    },
    isAvailable() {
        return this.props.value.isAvailable;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var iconSrc;

        if (this.state.isOver == true) {
            textColor = '#2299D6';
            iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png';
        } else {
            textColor = '#000000';
            iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/selectedTheme.png';
        }

        const scrollWidth = 15;
        const hGap = 10;
        const bottomGap = 14;
        const textHeight = 17;
        const buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
        const buttonHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;

        const tabStyle = {
            position: 'absolute',
            width: buttonWidth,
            height: buttonHeight,
            top: this.props.index * buttonHeight,
            left: hGap,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none',
            display: 'flex',
            textAlign: 'left'
        };

        var disabledArea = 'none';

        if (this.isAvailable() == false) {
            textColor = 'lightgrey';
            disabledArea = 'block';
        }

        const spanStyle = {
            position: 'absolute',
            color: textColor,
            fontSize: 13,
            width: this.props.accordionWidth - 2 * hGap - scrollWidth - 5,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            top: 0
        };

        const iconStyle = {
            position: 'absolute',
            top: textHeight,
            left: 0,
            width: buttonWidth,
            height: buttonWidth * 9 / 16
        };

        var iconVisible;

        if (this.props.value.name == appParameters.currentVideoTheme)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const checkIconStyle = {
            position: 'absolute',
            bottom: 19,
            right: 5,
            display: iconVisible,
            width: 40,
            height: 40
        };

        const disabledStyle = {
            position: 'absolute',
            top: textHeight,
            left: 0,
            width: buttonWidth,
            height: buttonWidth * 9 / 16,
            background: 'white',
            opacity: 0.5,
            display: disabledArea
        };

        return (
            <button aria-label={this.props.value.title} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onClick={this.onClick} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.props.value.title}</span>
                <img alt='' aria-hidden='true' style={iconStyle} src={this.props.href}/>
                <img alt='' aria-hidden='true' style={checkIconStyle} src={iconSrc}/>
                <div style={disabledStyle}/>
            </button>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    var clipartCategory = state.menu.clipartCategory;
    var isVideoClipart = false;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (clipartCategory == 1)
        isVideoClipart = true;

    return {
        accordionWidth,
        isVideoClipart
    };
}

export const ClipartSelectorButtonExpanded = connect(mapStateToProps)(ClipartSelectorButtonExpandedContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ClipartSelectorButtonExpanded.js
 **/